export default __webpack_public_path__ + "static/media/vip12-bg.b1cac9e1.webp";